import ThankYou from "./ThankYou";
export default ThankYou;
